import { ProjectStructure } from "@mydocma/project";

export interface Structure extends ProjectStructure {
  myDocmaUid?: string;
}

export interface StructureNode extends Structure {
  path: string;
  parent?: StructureNode
  children?: StructureNode[];
}
export class StructureTree implements StructureNode {
  id: string;
  path: string;
  parent?: StructureNode;
  children?: StructureNode[];
  name: string;
  desc?: string;
  level: number;
  externalId?: string;
  myDocmaUid?: string;

  static loadTree(structures: Structure[]): StructureTree {
    let root: StructureNode = { id: '', name: '', desc: '', path: '', level: 0 };
    structures.map((str) => {
      if ( str.level === 0 ) {
        root = StructureTree.loadNode(str);
      } else {
        const node: StructureNode = StructureTree.loadNode(str);
        let lastAddedNoodInTree = StructureTree.getLastAddedTreeNode( root );
        const parent = StructureTree.findNodeParent(node, lastAddedNoodInTree);
        node.path = parent.path + '/' + str.name;
        node.parent = parent;
        parent.children.push(node);
      }
    })
    return root;
  }

  static nodeUid(node: StructureNode): string {
    return node?.myDocmaUid ?? (node as any)?.uid;
  }

  static getNodeByMyDocmaUid(node: StructureNode, myDocmaUid: string): StructureNode {
    if (!node || !myDocmaUid) return null;
    if (StructureTree.nodeUid(node) === myDocmaUid) return node;
    for (const child of node.children ?? []) {
      const found = StructureTree.getNodeByMyDocmaUid(child, myDocmaUid);
      if (found) return found;
    }
    return null;
  }

  private static loadNode(node): StructureNode {
    return {
      id: node.id,
      name: node.name,
      desc: node.desc,
      path: node.name,
      level: node.level,
      children: []
    };
  }

  private static getLastAddedTreeNode( tree ) {
    if ( tree.children.length > 0 ) {
      return StructureTree.getLastAddedTreeNode( tree.children[tree.children.length - 1] );
    }
    return tree;
  }

  private static getParent( node ) {
    return node.parent;
  }

  private static findNodeParent( node, lastAddedNoodInTree ) {

    if ( node.level < lastAddedNoodInTree.level ) {
      while ( lastAddedNoodInTree.level > node.level ) {
        lastAddedNoodInTree = StructureTree.getParent(lastAddedNoodInTree.parent);
      }
    }

    if ( node.level > lastAddedNoodInTree.level ) {
      return lastAddedNoodInTree;
    }

    if ( lastAddedNoodInTree.level === node.level ) {
      return lastAddedNoodInTree.parent;
    }

  }
}

